import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserPaletteDb = {
  userId: string;
  paletteId: string;
  order: number;
}
const initial: RelationUserPaletteDb = {
  userId: '',
  paletteId: '',
  order: 0
};

export type RelationUserPaletteDbHashType = {
  [key in string]: RelationUserPaletteDb;
}

export type RelationUserPaletteAddPayload = {
  id?: string;
} & RelationUserPaletteDb;
export type RelationUserPaletteUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserPaletteDb]?: RelationUserPaletteDb[P] };

export type RelationUserPaletteDbState = {
  relationUserPalettes: RelationUserPaletteDbHashType;
}

export const generateRelationUserPaletteId = (): string => generateId('rup');
let initialState: RelationUserPaletteDbState = { relationUserPalettes: {} };
const key = 'relationUserPalettes';

const relationUserPaletteDbSlice = createSlice({
  name: 'relationUserPaletteDb',
  initialState,
  reducers: {
    initializeRelationUserPalettes(state: RelationUserPaletteDbState) {
      state.relationUserPalettes = {};
    },
    addRelationUserPalette(state: RelationUserPaletteDbState, action: PayloadAction<RelationUserPaletteAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserPaletteId();
      state.relationUserPalettes[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserPalette(state: RelationUserPaletteDbState, action: PayloadAction<RelationUserPaletteUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserPalettes[id] === undefined) {
        console.log(`*** RelationUserPalette not found: ${id}`);
      } else {
        const newData = { ...state.relationUserPalettes[id], ...obj };
        state.relationUserPalettes[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserPalette(state: RelationUserPaletteDbState, action: PayloadAction<RelationUserPaletteUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserPalettes[id];
      deleteData(key, id);
    },
    saveRelationUserPalettes(state: RelationUserPaletteDbState) {
      saveAllData(key, state.relationUserPalettes);
    },
    signUpRelationUserPalettes(state: RelationUserPaletteDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserPalettes, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserPaletteDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserPalettes = updatedValues;
      if (changed) saveAllData(key, state.relationUserPalettes);
    })
  }
})

export const { initializeRelationUserPalettes, addRelationUserPalette, updateRelationUserPalette, deleteRelationUserPalette, saveRelationUserPalettes, signUpRelationUserPalettes } = relationUserPaletteDbSlice.actions;
export default relationUserPaletteDbSlice.reducer;
